/* API Context */
import {getRequest, getRequestFile, postRequest} from "../fetchWrapper";

/**
 * Récupération des condoléances d'un défunt.
 *
 * @param string $token Jeton d'authentification.
 * @param int $id Identifiant du défunt.
 * @returns Response | null Réponse de la requête à l'API.
 */
export const getDeceasedCondolenceList = (token, id) => {
    const url = `/api-v1/deceased/${id}/condolence/list`
    return getRequest(url, token)
};

/**
 * Récupération des condoléances pour une agence.
 *
 * @param string $token Jeton d'authentification.
 * @param int $id Identifiant de l'agence.
 * @returns Response | null Réponse de la requête à l'API.
 */
export const getAgencyCondolenceList = (token, id) => {
    const url = `/api-v1/agency/${id}/condolence/list`
    return getRequest(url, token)
};

/**
 * Mise à jour du statut de modération d'une condoléance.
 *
 * @param string $token Jeton d'authentification.
 * @param object $body Corps de la requête.
 * @returns Response | null Réponse de la requête à l'API.
 */
export const updateModeratedStatus = (token, body) => {
    const url = `/api-v1/condolence/moderate`
    return postRequest(url, body, token)
};

/**
 * Mise à jour du statut de publication d'une condoléance.
 *
 * @param string $token Jeton d'authentification.
 * @param object $body Corps de la requête.
 * @returns Response | null Réponse de la requête à l'API.
 */
export const updatePublishedStatus = (token, body) => {
    const url = `/api-v1/condolence/publish`
    return postRequest(url, body, token)
};

/**
 * Mise à jour du statut d'impression d'une condoléance.
 *
 * @param string $token Jeton d'authentification.
 * @param object $body Corps de la requête.
 * @returns Response | null Réponse de la requête à l'API.
 */
export const updatePrintedStatus = (token, body) => {
    const url = `/api-v1/condolence/print`
    return postRequest(url, body, token)
};

/**
 * Rejet d'une condoléance.
 *
 * @param string $token Jeton d'authentification.
 * @param object $body Corps de la requête.
 * @returns Response | null Réponse de la requête à l'API.
 */
export const rejectCondolence = (token, body) => {
    const url = `/api-v1/condolence/reject`
    return postRequest(url, body, token)
};

/**
 * Acceptation d'une condoléance.
 *
 * @param string $token Jeton d'authentification.
 * @param object $body Corps de la requête.
 * @returns Response | null Réponse de la requête à l'API.
 */
export const acceptCondolence = (token, body) => {
    const url = `/api-v1/condolence/accept`
    return postRequest(url, body, token)
};

/**
 * Envoi d'un message de condoléances de la part d'une PF.
 *
 * @param object $body Corps de la requête.
 * @param string $token Jeton d'authentification.
 * @returns Response | null Réponse de la requête à l'API.
 */
export const uploadPfMessage = (body, token) => {
    const url = `/api-v1/condolence/pf`
    return postRequest(url, body, token)
};

/**
 * Mise à jour d'un message de condoléances.
 *
 * @param object $body Corps de la requête.
 * @param string $token Jeton
 * @returns Response | null Réponse de la requête à l'API.
 */
export const updateCondolenceMessage = (body, token) => {
    const url = `/api-v1/condolence/update`
    return postRequest(url, body, token)
};

/**
 * Téléchargement du mémo des obsèques.
 *
 * @param string $token Jeton d'authentification.
 * @param int $deceased Identifiant du défunt.
 * @returns Response | null Réponse de la requête à l'API.
 */
export const printCondolences = (token, id) => {
    const url = `/api-v1/condolence/${id}/print`;
    return getRequestFile(url, token)
}